<template>
	<div>
		<el-dialog title="修改科三考试规则" width="1100px" class="icon-dialog" :visible.sync="show" @open="open"
			:before-close="closeForm" append-to-body>
			<el-form :size="size" ref="form" :model="form" :inline="true">
				<el-row>
					<div >
						<quill-editor ref="text" v-model="form.content" class="editor" :options="editorOption" />
					</div>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getartedit } from '../../api/userMG';
import '../../assets/css/quillEditor.css';
//引入Qill插件
import Quill from "quill";

// 自定义字体
let fontFamily = ['宋体', '黑体', '微软雅黑', '楷体', '仿宋', 'Arial', '苹方'];
Quill.imports['attributors/style/font'].whitelist = fontFamily;
Quill.register(Quill.imports['attributors/style/font']);

// 自定义文字大小
let fontSize = ['10px', '12px', '14px', '16px', '20px', '24px', '36px']
Quill.imports['attributors/style/size'].whitelist = fontSize;
Quill.register(Quill.imports['attributors/style/size']);

// 新增行高
let Parchment = Quill.import("parchment");
let lingHeight = ['initial', '1', '1.5', '1.75', '2', '3', '4'];
class lineHeightAttributor extends Parchment.Attributor.Style { }
const lineHeightStyle = new lineHeightAttributor("lineHeight", "line-height", {
	scope: Parchment.Scope.INLINE,
	whitelist: lingHeight
});
Quill.register({ "formats/lineHeight": lineHeightStyle }, true);

// 对齐方式样式都改成style方式，而不是class
let Align = Quill.import('attributors/style/align');
Align.whitelist = ['right', 'center', 'justify'];
Quill.register(Align, true);

const toolbarOptions = [
	[
		"bold",
		"italic",
		"underline",
		"strike",
		"blockquote",
		"code-block",
		{ header: 1 },
		{ header: 2 },
		{ list: "ordered" },
		{ list: "bullet" },
		{ indent: "-1" },
		{ indent: "+1" },
		{ script: "sub" }, // 下标
		{ script: "super" }, // 上标
		{ align: [] },
		{ color: [] },
		{ background: [] },
		"link",
		"image",
	],
	[{ size: fontSize }], // 文字大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
	[{ font: fontFamily }], // 字体
	[{ lineheight: lingHeight }]   // 行高
];
export default {
	name: 'Add',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
        info:{
			type: Object,
        }
	},
	data() {
		return {
			form: {},
			editorOption: {
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							lineheight: function (value) {
								if (value) {
									this.quill.format('lineHeight', value);
								} else {
									console.log(value);
								}
							},
						},
					}
				},
			},
			loading: false,
			rules: {
			}
		}
	},
	methods: {
		open() {
            this.form = this.info
			this.form.echo = 'set'
		},
		submit() {
			console.log(this.form);
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					getartedit(this.form).then(res => {
						console.log(res.code);
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
						} else {
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/views/secret/upadd3.vue